import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService } from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';
import { UserSessionService } from '../services/user-session.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-nuovo-consuntivatore',
  templateUrl: './nuovo-consuntivatore.component.html',
  styleUrls: ['./nuovo-consuntivatore.component.scss']
})
export class NuovoConsuntivatoreComponent implements OnInit {
  user: any;
  myBranchUrl: SafeResourceUrl;
  title = 'Nuovo Consuntivatore';
  subTitle = 'EDAC - Nuovo Consuntivatore';
  selectedVenue: any = false;
  private sub: Subscription;
  currentCompany: any = null;
  innerHeight: any;

  constructor(
    public navService: NavService,
    public translate: TranslatorService,
    private authService: AuthService,
    private userSessionService: UserSessionService,
  ) { }

  setPageVisibility(company: any) {
    this.selectedVenue = company != 0 ? true : false;
  }

  getCompany() {
    const company = this.userSessionService.getState('working_company');
    if (!(company == null) && !(company.name == '*')) {
      return company.id;
    } else return 0;
  }

  loadLabels() {
    this.translate.get('SIDEBAR.NuovoConsuntivatore').subscribe(res => {
      if (res && res !== 'SIDEBAR.NuovoConsuntivatore') {
        this.title = res;
        this.subTitle = 'EDAC - ' + res;
      }
    });
  }

  ngOnInit(): void {
    this.currentCompany = this.getCompany();
    this.setPageVisibility(this.currentCompany);

    this.sub = this.userSessionService.$changeCompanyDetector.subscribe(() => {
      window.location.reload();
    });

    this.user = this.authService.user();
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
    this.navService.setWikiKey('NODEF');
    this.navService.setActions([]);
    this.innerHeight = (window.innerHeight - 74) + 'px';

    if (this.selectedVenue) {
      this.myBranchUrl = environment.rootNuovoConsuntivatore + this.user.sub + `&idSede=${this.currentCompany}`;
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
